<script>
import axios from 'axios'
import adminTable from './mixins/adminTable'
import { mapGetters } from 'vuex'
export default
{
    mixins: [ adminTable ],

    computed:
    {
        ...mapGetters({
            data: 'artistList',
            categories: 'artistCatgoriesList',
        }),

        exportUrl() {
            return `${process.env.API_URL}/../eloadok.csv`
        }
    },

    watch:
    {
        data()
        {
            this.updateData()
        },
    },

    methods:
    {
        fetch()
        {
            this.$store.dispatch('artistFetch')
            this.$nextTick(() => {
                this.updateData()
            })
        },

        afterUpdateModel(obj)
        {
            this.$store.dispatch('artistUpdate', obj).then(() =>{ this.fetch() })
            this.$store.dispatch('artistCategoryFetch')
        },

        afterDeleteModel(obj)
        {
            this.$store.dispatch('artistDelete', obj).then(() =>{ this.fetch() })
            this.$store.dispatch('artistCategoryFetch')
        },

        afterAddModel(obj)
        {
            this.$store.dispatch('artistNew', obj).then(() =>{ this.fetch() })
            this.$store.dispatch('artistCategoryFetch')
        },

        applyCategoriesFilter(cat)
        {
            this.$store.commit(this.tableName + '/SET_CUSTOM_FILTER', {filter: 'categories', value: cat})
        },

        applyStatusFilter(status)
        {
            this.$store.commit(this.tableName + '/SET_CUSTOM_FILTER', {filter: 'status', value: status})
        },

        deleteMany()
        {
            this.$snotify.confirm(this.$t('GENERAL.DELETE_MODEL', { model: '' + this.checked.length + ' elemet' }), this.$t('GENERAL.DELETE'), {
                buttons: [
                    {text: this.$t('GENERAL.YES'), action: (toast) => {
                        this.$snotify.remove(toast.id)

                        axios.delete(`${process.env.API_URL}/v1/admin/artists`, { params: { models: this.checked }}).then(res => {
                            this.checked = []
                            this.fetch()
                        }).catch(e => {})

                    }, bold: false},
                    {text: this.$t('GENERAL.NO'), action: (toast) => this.$snotify.remove(toast.id) },
                ]
            })
        },

        emptySelected()
        {
            this.checked = []
        }

    },

    data()
    {
        return {
            url: '/v1/admin/artists',
            tableName: 'tableArtists',
            emptyModel: { name: null, attachments: [], categories: [], on_site: false, on_mobile: false },
            columns: [ 'id', 'picture', 'name', 'name_en', 'status', 'created_at', 'updated_at', 'category', 'programs', 'actions' ],
            checked: [],
            options: {
                headings: {
                    actions: this.$t('TABLE.ACTIONS'),
                    name: this.$t('ARTIST.NAME'),
                    name_en: this.$t('PROGRAM.NAME_EN'),
                    picture: this.$t('GENERAL.IMAGE'),
                    created_at: this.$t('GENERAL.CREATED_AT'),
                    updated_at: this.$t('GENERAL.UPDATED_AT'),
                },
                perPage: 25,
                saveState: true,
                highlightMatches: true,
                filterByColumn: false,
                columnsDropdown: true,
                toMomentFormat: true,
                filterable: ['name', 'created_at', 'updated_at'],
                customFilters: [{
                    name: 'categories',
                    callback: function(row, query) {
                        for (let i = 0; i < row.categories.length; ++i)
                        {
                            if (row.categories[i].id == query.id)
                                return true;
                        }
                        return false
                    }
                },{
                    name: 'status',
                    callback: function(row, query) {
                        const flattened = []
                        if (query.length == 0) return true // YOLO
                        for (let i = 0; i < query.length; ++i)
                            flattened.push(query[i].id)

                        let visible = true

                        if (flattened.includes('site'))
                            visible = visible && row.on_site == 1
                        if (flattened.includes('not_site'))
                            visible = visible && row.on_site == 0

                        if (flattened.includes('mobile'))
                            visible = visible && row.on_mobile == 1
                        if (flattened.includes('not_mobile'))
                            visible = visible && row.on_mobile == 0

                        if (flattened.includes('category'))
                            visible = visible && ( row.categories && row.categories.length > 0 )
                        if (flattened.includes('not_category'))
                            visible = visible && ( row.categories == null || row.categories.length == 0)

                        if (flattened.includes('program'))
                            visible = visible && ( row.programs && row.programs.length > 0 )
                        if (flattened.includes('not_program'))
                            visible = visible && ( row.programs == null || row.programs.length == 0)

                        return visible
                    }
                }
                ],
            },
            statusOptions: [
                {
                    id: 'site',
                    label: 'Oldalon',
                },

                {
                    id: 'not_site',
                    label: 'Nincs az Oldalon',
                },

                {
                    id: 'mobile',
                    label: 'Mobilon',
                },

                {
                    id: 'not_mobile',
                    label: 'Nincs mobilon',
                },

                {
                    id: 'category',
                    label: 'Van kategóriája',
                },

                {
                    id: 'not_category',
                    label: 'Nincs kategóriája',
                },

                {
                    id: 'program',
                    label: 'Van programja',
                },

                {
                    id: 'not_program',
                    label: 'Nincs programja',
                },
            ],
        }
    },

}
</script>

<template>
    <div class="container-fluid">
        <div class="form-group row">
            <label for="name" class="col-md-2 control-label text-left">
                {{ $t('ARTIST.CATEGORY') }}
            </label>
            <div class="col-md-3">
                <v-select :options="categories" label="name" @input="applyCategoriesFilter">

                </v-select>
            </div>
            <label for="name" class="col-md-2 control-label text-left">
                {{ $t('PROGRAM.STATUS') }}
            </label>
            <div class="col-md-3">
                <v-select :options="statusOptions" multiple @input="applyStatusFilter">

                </v-select>
            </div>
            <!-- Add icon button for export Url -->
            <div class="col-md-2 text-right">
                <a :href="exportUrl" class="btn btn-success">
                    <icon name="download"></icon>
                    {{ $t('GENERAL.EXPORT') }}
                </a>
            </div>
        </div>
        <mv-modal ref="form">
            <span slot="header">{{ $t('ARTIST.ARTIST') }}</span>
            <mv-artist-form :model="model" :edit="formEdit" @save="saveForm"></mv-artist-form>
            <div slot="footer">
                <button class="btn btn-success" @click="closeForm">{{ $t('GENERAL.CANCEL') }}</button>
                <button class="btn btn-primary" @click="saveForm">{{ $t('GENERAL.SAVE') }}</button>
            </div>
        </mv-modal>
        <div class="panel panel-primary">
            <div class="panel-heading">
                <div class="row">
                    <div class="col-sm-10">
                        <h4>{{ $t('MENU.ARTISTS') }}</h4>
                    </div>

                    <div class="col-sm-2 text-right">
                        <button class="btn btn-xs btn-warning" @click="newModel">
                            <icon name="plus"></icon>
                        </button>
                        <button class="btn btn-xs btn-success" @click="exportFile">
                            <icon name="download"></icon>
                        </button>
                    </div>
                </div>
            </div>
            <div class="panel-body">

                <div  v-if="checked && checked.length > 0" class="text-center">
                    <button class="btn btn-xs btn-warning" @click="deleteMany">
                        <span>
                            {{ checked.length }} Elem Törlése
                        </span>
                    </button>

                    <button class="btn btn-xs btn-success" @click="emptySelected">
                        <span>
                            {{ $t('GENERAL.CANCEL') }}
                        </span>
                    </button>
                </div>
                <v-client-table :data="data" :columns="columns" :options="options" :name="tableName" ref="table">
                    <div slot="id" slot-scope="props">
                        <input type="checkbox" v-model="checked" :value="props.row.id">
                        {{ props.row.id }}
                    </div>
                    <div slot="actions" slot-scope="props" class="text-center">
                        <button class="btn btn-xs btn-warning" @click="delModel(props.row, props.row.name)">
                            <icon name="remove"></icon>
                        </button>
                        <button class="btn btn-xs btn-primary" @click="updateModel(props.row)">
                            <icon name="edit"></icon>
                        </button>
                    </div>
                    <div slot="picture" slot-scope="props">
                        <div class="text-center" v-if="props.row.attachments && props.row.attachments.length > 0">
                            <img :src="props.row.attachments[0].thumbnail_url">
                        </div>
                    </div>
                    <div slot="status" slot-scope="props">

                        <div class="label" :class="{ 'label-warning': !props.row.on_mobile, 'label-success': props.row.on_mobile}">
                            Mobilon
                        </div>

                        <div class="label" :class="{ 'label-warning': !props.row.on_site, 'label-success': props.row.on_site}">
                            Oldalon
                        </div>
                    </div>
                    <div slot="child_row" slot-scope="props">
                        <div v-html="props.row.description">
                        </div>
                    </div>

                    <div slot="programs" slot-scope="props">
                        <div v-if="props.row.programs && props.row.programs.length > 0">
                            <div class="label label-primary" v-for="program in props.row.programs" :key="program.id">
                                {{ program.name }}<br>
                            </div>
                        </div>
                    </div>
                    <div slot="category" slot-scope="props">
                        <div  v-if="props.row.categories && props.row.categories.length > 0">
                            <div v-for="cat in props.row.categories" class="label label-primary" :key="cat.id">
                                {{ cat.name }}<br>
                            </div>
                        </div>
                    </div>
                </v-client-table>
            </div>
        </div>
    </div>
</template>




// WEBPACK FOOTER //
// src/pages/Artists.vue